import sponsorLogo from "@assets/keyword/abs-ocbc-logo.svg";
import logo from "@assets/keyword/logo-afs.png";
import { cn } from "@util/helpers";

export type AsiaFutureSummitLogoProps = {
  /** classname for asia summit logo component */
  className?: string;
};

/** New header styling as per figma for asia-future-summit
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB-?node-id=0-1&t=z26dJGcy5tLcNcKs-1
 */
const AsiaFutureSummitLogo = ({ className }: AsiaFutureSummitLogoProps) => {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-center justify-between md:flex-row",
        className
      )}
      data-testid="asia-future-summit-logo-component"
    >
      <img
        src={logo}
        width={235}
        height={77}
        alt="ASIA FUTURE SUMMIT 2025"
        className="object-cover"
      />

      <div className="mt-4 flex w-full flex-wrap items-center justify-center gap-6 border-t border-gray-850 pt-4 text-center md:w-auto md:flex-row md:border-none md:text-left">
        <p className="mb-0 mt-1  font-poppins text-xs uppercase text-black">
          Presenting Sponsor
        </p>

        <img
          src={sponsorLogo}
          width={160}
          height={48}
          alt="OCBC PREMIER BANKING"
          className="inline-block object-cover"
        />
      </div>
    </div>
  );
};

export default AsiaFutureSummitLogo;
